function userVoice() {
    UserVoice = window.UserVoice || []; (function () { 
    var uv = document.createElement('script'); 
    uv.type = 'text/javascript'; uv.async = true; 
    uv.src = '//widget.uservoice.com/hcRvYu0ptNzRD4wlcplp9g.js'; 
    var s = document.getElementsByTagName('script')[0]; 
    s.parentNode.insertBefore(uv, s) })();
    UserVoice.forumID = '923338';

    //Commented the below to fix DSI issue where it points towards wrong forum id
    // if (document.getElementById('feedback') !== undefined && document.getElementById('feedback') !== null) {
        UserVoice.push(['set', {
            accent_color: '#448dd6',
            trigger_color: 'white',
            forum_id: UserVoice.forumID,
            trigger_background_color: 'rgba(46, 49, 51, 0.6)',
            mode: 'post_idea',
            position: 'automatic',
            target: 'self'
        }]);
    //}
}



//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/assets/js/userVoice.js
// module id = ../../../../../src/assets/js/userVoice.js
// module chunks = main